<template>
    <div>

        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <b-pagination v-model="filter.page" :total-rows="rows" :per-page="filter.pageSize"
            aria-controls="table-list-users" class="m-2" pills>
        </b-pagination>

    </div>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'

export default {
    name: 'PaginationUser',

    data() {
        return {
            filter: {
                page: 1,
                pageSize: InitPageSize.UsersPageSize
            },

            rows: 0
        }
    },

    components: {
        AlertDismiss
    },

    async mounted() {
        await this.getCountUsers();

        //emitimos el evento para inicializar los valores de la tabla usuarios
        await this.paginationFilterUsers();
    },

    methods: {
        ...mapActions(["countUsers"]),

        paginationFilterUsers() {
            this.$eventBus.$emit(EventNames.PaginationFilterUsers, this.filter);
        },

        async getCountUsers() {
            let result = await this.countUsers();
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.rows = result.data;
        }

    },

    watch: {
        //cada ves que se haga un click al paginador entonces emite el evento
        async "filter.page"() {
            this.paginationFilterUsers();
        },
    },

}
</script>
<style></style>